var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.extraFields),function(value,key){return _c('div',{key:key,staticClass:"columns"},[_c('div',{staticClass:"column is-half"},[_vm._v(" "+_vm._s(key)+" ")]),_c('div',{staticClass:"column is-half"},[_vm._v(" "+_vm._s(value)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }